import cookie from "react-cookies"
import memberServices from "../services/MemberService"
import { MarketFilter, Market, BetTypeGroup, LoginStatus, VIEW , ViewPath} from "../common/Foundation"
import moment from "moment-timezone"
import CommonUtil from "../common/CommonUtil"
import _ from 'lodash'
import { Base64 } from 'js-base64'
import i18next from 'i18next';
import { EVENT } from '../events/listEvents';
import '../common/Extensions'
import $ from 'jquery';
import Constants from "../common/Constants";

export default class AccountAction {

    static LOGIN_SUCCESS = [
        LoginStatus.SUCCESS_WITH_STT_1,
        LoginStatus.SUCCESS_WITH_STT_2,
        LoginStatus.SUCCESS_WITH_STT_3, 
        LoginStatus.SUCCESS_WITH_STT_6,
        LoginStatus.SUCCESS_WITH_STT_7
    ]

    static translate(key, param) {
        return i18next.t(key, param)
    }

    static fireEventReloadAccountBalance() {
        window.fireEvent(EVENT.ACCOUNT_BALANCE_RELOAD);
    }

    static checkTrustCodeExisted(loginId) {
      const trustCodeStorage = localStorage.getItem("trustCode");
      const trustCodeObj = JSON.parse(trustCodeStorage);
      return trustCodeObj && !_.isNil(trustCodeObj[loginId])
    }

    static addTrustCodeToLocalStorage(loginId) {
        const trustCodeCookie = cookie.load('trustCode')
        if (!_.isString(trustCodeCookie) || !_.isString(loginId)) {
            return
        }
        const trustCodeStore = JSON.parse(localStorage.getItem('trustCode') || '{}')
        trustCodeStore[loginId] = trustCodeCookie
        return localStorage.setItem('trustCode', JSON.stringify(trustCodeStore))
    }

    static async sendActiveEmail(params) {
      return await memberServices.getActiveLink(params).then(res => {
        return res.data;
      });
    }

    static async signin(loginId, password, captcha = "", captchaToken = "") {
        let resultFailed = { auth: false, options: null, message: '' }
        try {
            let response = await memberServices.postLoginAPI(loginId, password, captcha, captchaToken)
            if (response.data === LoginStatus.BLOCKED_IP_RING_FENCING && !CommonUtil.isPA()) {
                window.location.href = "/" + CommonUtil.getCurrentLang() + "/block-page";
                return resultFailed;
            }
            this.loginError(resultFailed, response)
            //delete trust code in localstorage if invalid trust code
            if(window.env.isEnableTrustCodeValidation 
              && (response.data === LoginStatus.INVALID_TRUSTCODE 
                || (!resultFailed.auth && !_.isEmpty(resultFailed.message)))) {
                  if(AccountAction.checkTrustCodeExisted(loginId)) {
                    const data = JSON.parse(localStorage.getItem("trustCode") || {});
                    delete data[loginId];
                    localStorage.setItem("trustCode",  JSON.stringify(data))
                  }
            }
            if (!resultFailed.auth && !_.isEmpty(resultFailed.message)) {
                return resultFailed
            }
            // Handle login success
            let options = this.setInfoAfterLogin();
            if (this.LOGIN_SUCCESS.includes(response.data)) {
                if (LoginStatus.SUCCESS_WITH_STT_3 == response.data) {
                    this.clearCookieAcceptTC(true)
                }
                localStorage.setItem('isLoginSuccessFirstTime', true)
                localStorage.removeItem('oddsFormat');
                return { auth: true, options: options, message: this.translate('errors:SUCCESS_LOGIN'), loginStatus: response.data }
            }
            let result = response.data.split('\n')
            if (!_.isNil(result) && result.length > 1) {
                if (!_.isNil(result[3])) {
                    let dateTime = moment(new window.DateTZ(window.parseInt(result[2]))).format('ddd, MMM DD, YYYY HH:mm [GMT]Z')
                    let msg = this.translate('errors:SUCCESS_LOGIN_AFTER_FAILED', { 0: result[0], 1: result[1], 2: dateTime })
                    return { auth: true, options: options, message: msg, isDisplayAlert: true, loginStatus: result[3] }
                } else {
                    return { auth: false }
                }
            }
            return resultFailed;
        } catch (e) {
            if (e.response && e.response.status === 429) {
                resultFailed.message = this.translate('errors:ERROR_TOO_MANY_REQUEST');
            } else {
                resultFailed.message = this.translate('errors:ERROR_SERVICE', {0: 'login'});
            }
            return resultFailed
        }
    }

    static async handleLoginResultSuccess(loginStatus) {
        return await this.getDataNoCache().then(res => {
            let lang = CommonUtil.getCurrentLang();
            // Handle change password / security quesion
            let usingAccount = CommonUtil.isPA() ? "" : "/account";
            if (loginStatus == LoginStatus.SUCCESS_WITH_STT_2) {
                localStorage.setItem('_needToChangePW', true);
                if (window.location.hostname.match(/local/)) {
                    return "/" + lang + usingAccount + "/change-password?advised&wStandard&toLogin"
                } else {
                    if (window.location.pathname.indexOf('register') == -1) {
                        return "/dns-dispatcher/service/dispatch?purpose=MemberSite&next=/" + lang + usingAccount + "/change-password?advised%26wStandard%26toLogin"
                    }
                }
            } else if (loginStatus == LoginStatus.SUCCESS_WITH_STT_7) {
                localStorage.setItem('_needToChangePW', true);
                if (window.location.hostname.match(/local/)) {
                    return "/" + lang + usingAccount + "/change-password?advised&wStandard&toLogin&securityqa"
                } else {
                    if (window.location.pathname.indexOf('register') == -1) {
                        return "/dns-dispatcher/service/dispatch?purpose=MemberSite&next=/" + lang + usingAccount + "/change-password?advised%26wStandard%26toLogin%26securityqa"                        
                    }
                }
            }
            localStorage.removeItem('_needToChangePW');
            
            const __udata = AccountAction.splitDataNoCache(res.data);
            const isLeaderboard = CommonUtil.isLeaderboard();
            const isBetBuilder = CommonUtil.isBetBuilder();
            const userLanguage = CommonUtil.getLangByLocale(__udata.locale)
            if (!(isLeaderboard || isBetBuilder) && __udata.view === VIEW.STANDARD) {
                // keeping the player stays on leaderboard if default view is standard
                AccountAction.updateCookieAndStorageFromUdata(__udata, __udata.skin);
                return CommonUtil.getEuroViewURL(userLanguage);
            }
            let viewPath = '';
            if (__udata.skinIsSupportedLastView || window.env.brandDefaultView !== '') {
                const lastView = cookie.load('_userDefaultView');
                viewPath = this.getViewPath(lastView);
            }
            let contextPath = "/" + userLanguage + viewPath + '/sports';
            // keeping the player stays on leaderboard if default view is not standard
            if (isLeaderboard || isBetBuilder) {
              // clicked on opt-in button before then the status is WAITING_LOGIN
              if (Number(cookie.load("optinSteps")) === Constants.OPTIN_STEPS.WAITING_LOGIN) {
                // update status to handle option after login successfully
                CommonUtil.saveCookie(
                  "optinSteps", 
                  Constants.OPTIN_STEPS.COMPLETE_OPTIN, { 
                    path: "/", domain: AccountAction.getSubDomain() 
                  }
                );
              }
              const parts = window.location.pathname
                .split("/")
                .filter(part => part);

              if (parts.length > 0) {
                contextPath = `/${userLanguage}/${parts.splice(1, parts.length - 1).join("/")}`;
              }
            }
            const dnsDispatch = window.location.hostname.match(/(local|.code88.asia|.oreo99.com)/)
                ? ""
                : "/dns-dispatcher/service/dispatch?purpose=MemberSite&next="
            return dnsDispatch + contextPath
        });
    }

   static gotoPage(path) {
        let pathName = `/${CommonUtil.getUserLanguage()}/${path}`;
        return path === "register" ? this.getRegisterPath(pathName) : pathName;
    }

    static getRegisterPath (pathName){
      const affCode = cookie.load("afrc") || '';
      const afRefCode = CommonUtil.getParameterByName("a") || affCode;
      if (afRefCode){
        const afTtId = cookie.load("afTtId") || '';
        const ttid = CommonUtil.getParameterByName("ttid") || afTtId
        pathName = `${pathName}?a=${afRefCode}`
        if (ttid && ttid != 0){
          pathName = `${pathName}&ttid=${ttid}`;
        }
        sessionStorage.setItem('reference_url', pathName);
      }
      return pathName;
    }

    static getCompactViewPath(){
      return (window.env.isEnableOldAsianView && window.env.isEnableNewAsianView) || (window.env.isB2B && window.env.isEnableNewAsianView)
        ? `/${ViewPath.compactView}`
        : '';
    }

    static getAccountViewPath() {
      return CommonUtil.isPA() ? `/${ViewPath.compactView}` : '';
    }

    static getViewPath(lastView, isForceCompact = true) {
        switch (lastView) {
            case VIEW.CLASSIC:
                return `/${ViewPath.classicView}`
            case VIEW.COMPACT:
                return isForceCompact? `/${ViewPath.compactView}`: this.getCompactViewPath();
            case VIEW.NEW_ASIAN:
                return isForceCompact? `/${ViewPath.compactView}`: this.getCompactViewPath();
            case VIEW.EUROPE:
                return `/${ViewPath.europeView}`
            default:
                return '';
        }

    }

    static loginError(resultFailed, response) {
        if (response.data == LoginStatus.INVALID_CAPTCHA) {
          resultFailed.message = this.translate('errors:INVALID_CAPTCHA')
          return resultFailed
        }
        if (response.data == LoginStatus.INVALID_TRUSTCODE) {
          resultFailed.message = this.translate('errors:INVALID_LOGINID_PASSWORD')
          return resultFailed
        }
        if (response.data == LoginStatus.INVALID_USER_OR_PASS) {
            // resultFailed.message = 'Please enter a valid login name and password.'
            resultFailed.message = this.translate('errors:INVALID_LOGINID_PASSWORD')
            return resultFailed
        }
        if (response.data == LoginStatus.LOGIN_FAILED) {
            // resultFailed.message = 'Login failed. Please contact Customer Service Support.'
            resultFailed.message = this.translate('errors:ERROR_LOGIN_FAILED')
            return resultFailed
        }
        if (response.data == LoginStatus.WRONG_COUNTRY) {
            // resultFailed.message = 'Your current IP address does not match your registration country.'
            resultFailed.message = this.translate('errors:INVALID_CURRENT_IP')
            return resultFailed
        }
        if (response.data == LoginStatus.ACCOUNT_UNVERIFIED) {
            // resultFailed.message = 'Your account is unverified.'
            resultFailed.message = this.translate('errors:ERROR_VERIFIED_ACCOUNT')
            return resultFailed
        }
        if (response.data == LoginStatus.WRONG_ODDS_FORMAT) {
            // resultFailed.message = 'Please check your odds format setting'
            resultFailed.message = this.translate('errors:INVALID_ODD_FORMAT')
            return resultFailed
        }
        if (!_.isNil(response.data) && !_.isNil(response.data.code)) {
            if (response.data.code == LoginStatus.ACCOUNT_SUSPENDED) {
                let message = response.data.userType == 'cash'
                    // ? 'Account suspended due to too many failed login attempts. Please contact Customer Service for assistance.'
                    // : 'Account suspended due to too many failed login attempts. Please contact your upline.'
                    ? this.translate('errors:ERROR_LOGIN_MUCH_TIME_CASH')
                    : this.translate('errors:ERROR_LOGIN_MUCH_TIME_CREDIT')
                resultFailed.message = message
                return resultFailed
            }
            if(response.data.code == LoginStatus.TRY_IN_FEW_MINS){
                let message = (response.data.userType).toLowerCase() == 'cash'
                    ?  this.translate('errors:ERROR_LIMIT_LOGIN_FAILED_FEW_MIN_CASH')
                    : this.translate('errors:ERROR_LIMIT_LOGIN_FAILED_FEW_MIN_CREDIT')
                resultFailed.message = message;
                return resultFailed;
            }
            if (response.data.code == LoginStatus.TRY_IN_20_MINS ) {
                let message = (response.data.userType).toLowerCase() == 'cash'
                    ?  this.translate('errors:ERROR_LIMIT_LOGIN_FAILED_20_MIN_CASH')
                    : this.translate('errors:ERROR_LIMIT_LOGIN_FAILED_20_MIN_CREDIT')
                resultFailed.message = message;
                return resultFailed;
            }
            if(response.data.code == LoginStatus.ACCOUNT_MIGRATED_TO_PS3838) {
                resultFailed.message = this.translate('errors:ERROR_ACCOUNT_MIGRATION', {0: response.data.url, 1: response.data.url});
                localStorage.setItem("urlMigration",  response.data.url);
                return resultFailed;
            }
        }
        if (response.data == LoginStatus.EXCEED_SESSION_TIME_LIMIT) {
            // resultFailed.message = 'Please check your odds format setting'
            resultFailed.message = this.translate('errors:You had exceed responsible gaming session time limit')
            return resultFailed
        }
        if (response.data.error === 'M004') {
            let tz = CommonUtil.getPrefByKey("timeZoneOffset");
            if (tz === null || tz === undefined) {
                tz = -moment().zone();
            }
            // If operator ticked on Exclusion checkbox
            if (moment(response.data.expire).diff(moment(), 'days') > 90) {
                resultFailed.message = this.translate('errors:Self Exclusion');
            } else {
                const date = moment(response.data.expire).zone(-tz).format(this.translate("format:ddd, MMM D, YYYY"));
                const time = moment(response.data.expire).zone(-tz).format("HH:mm A");
                resultFailed.message = this.translate('errors:' + response.data.error, { 0: date + ' ' + time });
            }
            return resultFailed
        }
    }

    static async logout(redirectUrl) {
        this.clearCookie();
        await memberServices.postLogoutAPI().then(response => {
          this.redirect(redirectUrl);
        }, err => {
          this.redirect(redirectUrl);
        })
    }

    static redirect(redirectUrl) {
        const pathname = redirectUrl ? redirectUrl : `/${CommonUtil.getCurrentLang()}${AccountAction.getCompactViewPath()}/sports`;
        if (_.get(window.env, 'isBrandEnableLogoutOnArcadia')) {
          window.location.href = this.getArcadiaURL(window.env.futureViewURL || window.env.fvURL || window.location.href, pathname);
        } else {
          window.location.reload();
        }
    }
      
    static getArcadiaURL (domain, pathname){
      const returnURL = encodeURIComponent(`${window.location.origin}${pathname}`);
      return `${domain.replace("/{locale}", "")}/${CommonUtil.getCurrentLang()}/?isLogout=true&returnUrl=${returnURL}&v=${new Date().getTime()}`
    }

    static async getDataNoCache() {
        return await memberServices.getDataNoCacheAPI()
    }

    static async checkIsSkinIsSupported(skin) {
        return memberServices.isSkinIsSupported(skin);
    }

    static setInfoAfterLogin() {
        let options = {}
        options.ogCache = cookie.load('_og') || ""
        let __prefs = CommonUtil.decodeBase64(cookie.load('__prefs'))
        let __prefsJSON = CommonUtil.convertStringToJSON(__prefs)
        let perfs = localStorage.getItem('perfs') || null
        let oldPrefs = _.isEmpty(perfs) ? {} : CommonUtil.convertStringToJSON(atob(perfs))
        
        options.timeZoneOffset = __prefsJSON[0] === null ? moment().utcOffset : __prefsJSON[0]
        options.oddsFormat = __prefsJSON[1]
        options.oddsMode = __prefsJSON[2]
        options.market = __prefsJSON[3] === 0 ? Market.Today : Market.ALL
        options.betTypeGroup = __prefsJSON[3] === 0 ? BetTypeGroup.HDP_OU : (__prefsJSON[3] === 1 ? BetTypeGroup.ML_1X2 : BetTypeGroup.TEAM_TOTAL)
        options.order = __prefsJSON[4]
        options.sportsSorting = __prefsJSON[5] && ("," + __prefsJSON[5] + ",")
        options.enableDefaultStake = __prefsJSON[6]
        options.defaultStake = __prefsJSON[7]
        options.acceptBetterOdds = __prefsJSON[8]
        options.updateBetslipOdds = __prefsJSON[9]
        options.marketFilter = this.castToMarketFilter(__prefsJSON[10]) || 5
        options.liveScoreNotify = __prefsJSON.length >= 12 ? __prefsJSON[11] : 0
        options.sound = (typeof (oldPrefs.sound) === "undefined" || true) ? true : false
        options.favourite = oldPrefs.favourite || false
        options.favouriteSportId = oldPrefs.favouriteSportId || 0
        options.timeFilter = oldPrefs.timeFilter || 0
        options.timeZoneId = __prefsJSON[12]
        options.liveContainerOnTopEnabled = __prefsJSON[13]
        options.isShowConfirmationModal = __prefsJSON[14]

        localStorage.setItem('perfs', btoa(JSON.stringify(options)))

        if (__prefsJSON[0] === null) {
            __prefsJSON[0] = moment().utcOffset
            let parts = document.domain.split('.')
            let domain = document.domain
            if (parts.length > 2) {
                parts.splice(0, parts.length - 2)
                domain = "." + parts.join(".")
            }
            CommonUtil.saveCookie('__prefs', btoa(JSON.stringify(__prefsJSON)), { path: "/", domain: AccountAction.getSubDomain() })
        }
        CommonUtil.saveCookie('auth', true, { path: '/', domain: AccountAction.getSubDomain() })

        //init data for Classic View
        if (document.URL.indexOf('classic') > -1) {
            let classicOptions = {}
            classicOptions.acceptBetterOdds = __prefsJSON[8]
            classicOptions.oddsFormat = __prefsJSON[1]
            let refreshData = localStorage.getItem('refresh_data') ? JSON.parse(Base64.decode(localStorage.getItem('refresh_data'))) : []
            Object.assign(refreshData, classicOptions);
            localStorage.setItem('refresh_data', Base64.encode(JSON.stringify(refreshData)))
        }

        return options
    }

    static castToMarketFilter = (marketDisplayType) => {
        switch (marketDisplayType) {
            case "ALL":
                return MarketFilter.All
            case "_1LINE":
                return MarketFilter._1Line
            case "_3LINES":
                return MarketFilter._3Lines
            case "_5LINES":
                return MarketFilter._5Lines
            default:
                return MarketFilter.Error
        }
    }

    static splitDataNoCache(__udata) {
        // reload page after convert session from Arcadia
        if (__udata.indexOf("udata") < 0) {
            eval(__udata);
        }

        let _UDATA = JSON.parse(__udata.replace("var __udata=", "").replaceAll(";", ""))
        _UDATA.currentView = ''
        return _UDATA
    }

    static async accountBalance() {
        return await memberServices.postAccountBalanceAPI().then(response => {
            if (response.data) {
                if (response.data.error) {
                    if (response.data.error === 'MULTIPLE_LOGIN') {
                        this.clearCookie()
                        window.fireEvent(EVENT.REFRESH_DATA);
                        if (
                            CommonUtil.isIniFrame() &&
                            window.env.enablePostLogoutMessage
                        ) {
                            CommonUtil.postMessage("lostSession", {
                                msgCode: "lostSession",
                                msgData: true
                            });
                        }
                        return this.dataObjectMultipleLogin(response)
                    }
                    if (response.data.msg) {
                        return { status: response.status, data: response.data.msg }
                    }
                } else if (!response.data.success) {
                    if ( response.data.isValidUserIPRingFencing === false && !CommonUtil.isPA()) { // will redirect to block page if isValidUserIPRingFencing equal false, not undefine or null 
                        window.location.href = "/" + CommonUtil.getCurrentLang() + "/block-page";
                        return response.data;
                    }
                }
            }
            this.setAccountInfo(response.data)
            return { status: response.status, data: response.data }
        }).catch(error => {
            this.clearCookie()
            if (!error.response) {
                return { status: 503, error: 'Network Error' }
            }
            return { status: error.response.status }
        })
    }

    static async getSumAnnouncementUnread() {
      return await memberServices.postSumAnnoucementUnreadAPI().then(response => {
          if (response.data && response.data.error) {
              if (response.data.msg) {
                  return { status: response.status, data: response.data.msg }
              }
          }
          return { status: response.status, data: response.data }
      }).catch(error => {
      })
  }

    static async getPreferences() {
        return memberServices.getPreferencesAPI()
    }
   
    static async postPreferences(payload) {
        return memberServices.postPreferencesAPI(payload)
    }
    
    static async getListTimeZones() {
        return memberServices.getListTimeZonesAPI()
    }
    
    static async getSportsSorting(country) {
        return memberServices.getSportsSortingAPI(country)
    }
    
    static async postSportsSorting(payload) {
        return memberServices.postSportsSorting(payload)
    }

    static setAccountInfo(accountInfo) {
        let account = {}
        account.auth = !_.isNil(accountInfo.loginId)
        if (account.auth) {
            account.auth = true
            account.loginId = accountInfo.loginId
            account.currency = accountInfo.currency
            account.betCredit = CommonUtil.formatBalance(accountInfo.betCredit)
            account.message = accountInfo.totalMessage
            account.sumAnnouncement = accountInfo.sumAnnouncement
        }
        localStorage.setItem('a', window.btoa(JSON.stringify(account)))
    }

    static changeRefresh() {
        let sync = document.getElementById('sync-refresh')
        if (_.isNil(sync)) {
            cookie.remove('auth', { path: '/', domain: AccountAction.getSubDomain() })
            return
        }
        sync.classList.add('fa-spin')
        setTimeout(function () {
            sync.classList.remove('fa-spin')
        }, 2000)
    }

    static dataObjectMultipleLogin(response) {

        return {
            error: _.get(response, 'data.error', ''),
            status: response.status,
            message: 'MULTIPLE_LOGIN',
            reload: true
        }
    }

    static async getAcceptTC(isPromoEmail, version) {
        return await memberServices.getAcceptTC(isPromoEmail, version).then(response => {
            return true
        }).catch(error => {
            return false
        })
    }

    static async getVersionTNC(linkTNC) {
        return await memberServices.getVersionTNC(linkTNC).then(response => {
            try{
                return $(response.data).find('.documentation__outline:first-child tbody>tr:nth-child(2) td:last').text();
            }catch (e){
                return ""
            }
        }).catch(error => {
            return ""
        })
    }

    static async acceptNewMobileBetslip() {
        try {
        const response = await memberServices.acceptNewMobileBetslip()
        return response.data
        } catch (err) {
            console.log(err)
            return false
        }
    }

    static async closeMorebetTooltip() {
        try {
        const response = await memberServices.closeMorebetTooltip()
        return response.data
        } catch (err) {
            console.log(err)
            return false
        }
    }

    static getSubDomain() {
        let parts = document.domain.split('.');
        let domain = document.domain;
        if (parts.length > 2 && isNaN(parts[0])) {
            parts.splice(0, parts.length - 2);
            domain = "." + parts.join(".");
        }
        return domain
    }

    static clearCookie() {
      // remove all the cookies which are added by client
        const cookies = cookie.loadAll();
      // keep this cookies for authenticate agent and arcadia user session
      const dynamicParamCookie = localStorage.getItem("_dp") ? localStorage.getItem("_dp").toLowerCase() : '';
      const keepCookiesSession = [`custid${_.get(window.env, 'arcadiaCookieSuffix')}`, `BrowserSessionId${_.get(window.env, 'arcadiaCookieSuffix')}`, '_partner', 'language', 'i18next', dynamicParamCookie];
      Object.keys(cookies)
          .filter(cookieName => !keepCookiesSession.some(item => cookieName.toLowerCase().includes(item)))
          .forEach(cookieName => {
            cookie.remove(cookieName, {path: '/'});
            cookie.remove(cookieName, {path: '/', domain: AccountAction.getSubDomain()});
      })
      localStorage.removeItem('showSurveyAgain');
      sessionStorage.removeItem('perfs');
      localStorage.removeItem('perfs');
      localStorage.removeItem('country');
      localStorage.removeItem('oddsFormat');
      localStorage.removeItem('themeMode');
      localStorage.removeItem('isRemindLiveScoreLater');
      localStorage.removeItem('_needToChangePW');  
	  localStorage.removeItem('token-user');
      localStorage.removeItem('secretKey'); 
      CommonUtil.saveUserData("newBetslipPopupEnabled", false); // Reset display new betslip popup when account is log out
    }

    static clearCookieAcceptTC(saveCookie = true) {
        cookie.remove('isShowAcceptTC', { path: '/' })
        cookie.remove('isShowAcceptTC', { path: '/', domain: AccountAction.getSubDomain() })
        if (saveCookie) {
            CommonUtil.saveCookie("isShowAcceptTC", true, { path: "/", domain: AccountAction.getSubDomain() })
        }
    }

    static setUserIP(userIp) {
        let localUserIp = window.atob(localStorage.getItem('rip')) || null
        if (typeof localUserIp === 'undefined' || localUserIp === null || localUserIp !== userIp) {
            localStorage.setItem('rip', window.btoa(userIp))
        }
    }

    static updateCookieAndStorageFromUdata(__udata, skin) {
        window.wagerMode = __udata.wagerMode;
        CommonUtil.setBase64LocalStorage('__udata', __udata);
        if (__udata.displayMode){
            localStorage.setItem('themeMode',__udata.displayMode);
        }
        CommonUtil.saveCookie('skin', skin, { path: "/", domain: AccountAction.getSubDomain() })
        CommonUtil.saveCookie('lang', __udata.locale, { path: "/", domain: AccountAction.getSubDomain() })
        AccountAction.setUserIP(__udata.userIp)
        localStorage.setItem('country', __udata.country)
    }

    static buildUserData(__udata, skin) {
        let userData;
        const isAuth = __udata.auth;
        const enableMaintenance = _.get(__udata, 'enableMaintenance', false);
        const defaultMode = localStorage.getItem('themeMode') || 'LIGHT';
        const displayMode = _.get(__udata, 'displayMode', defaultMode);
        const esportsLogoVersion = _.get(__udata, 'esportsLogoVersion', '');

        if (isAuth) {
            userData = {
                'auth': isAuth,
                'ataSender': __udata.ataSender,
                'loginId': __udata.loginId,
                'freshId': __udata.freshId,
                'email': __udata.email,
                'fullName': __udata.fullName,
                'mode': __udata.mode,
                'currency': __udata.currency,
                'token': __udata.token,
                'isMultipleBets': __udata.isEnableMultiBet,
                'type': __udata.type,
                'locale': __udata.locale,
                'skin': skin,
                'defaultView': __udata.view,
                'isBlockedCasino': __udata.isBlockedCasino,
                'status': __udata.status,
                'productStatus': __udata.productStatus,
                'enableMaintenance': enableMaintenance,
                'displayMode': displayMode,
                'currencyUnit': __udata.currencyUnit,
                'esportsLogoVersion': esportsLogoVersion,
                'defaultRBLimit':  __udata.defaultRBLimit,
                'blockedSports': __udata.blockedSports,
				'isBlockedWithdrawal': __udata.isBlockedWithdrawal,
                'isBlockedSBWagering': __udata.isBlockedSBWagering,
                'isBlockedHRWagering': __udata.isBlockedHRWagering,
                'supportLeftMenuWS': __udata.supportLeftMenuWS,
                'supportOddsPageWS': __udata.supportOddsPageWS,
                'usingNewLiveScoreWS': __udata.usingNewLiveScoreWS,
                'creditWithdrawalEnabled': __udata.creditWithdrawalEnabled,
                'hasVipWelcomeMessage': __udata.hasVipWelcomeMessage,
                'supportSpecialWS': __udata.supportSpecialWS
            }
        } else {
            userData = {
                'auth': isAuth,
                'country': __udata.country,
                'status': __udata.productStatus,
                'productStatus': __udata.productStatus,
                'enableMaintenance': enableMaintenance,
                'esportsLogoVersion': esportsLogoVersion
            }
        }
        userData.sportSuppLS = __udata.sportSuppLS;
        userData.liveBlockedSports = __udata.liveBlockedSports;
        userData.liveBlockedLeagues = __udata.liveBlockedLeagues
        userData.isBlockedLiveStreaming = __udata.isBlockedLiveStreaming;
        userData.maxBetPreferenceSettingBase = __udata.maxBetPreferenceSettingBase;
        return userData;
    }

    static updateThemeMode(userData){
      let htmlTag = document.getElementsByTagName("html")[0];
      const defaultMode= htmlTag.dataset.theme || 'LIGHT';
      if (
        !userData.auth && 
        window.env.isB2B && 
        window.env.enableDarkModeForGuest
      ) {
        htmlTag.dataset.theme = 'DARK';
        return;
      }

      if ( userData.displayMode && defaultMode !== userData.displayMode) {
        htmlTag.dataset.theme = userData.displayMode;
      }
    }

    static async changePassword (data) {
        return await memberServices.changePassword(data);
    }

    static handleMutipleLogin () {
        AccountAction.clearCookie();
        AccountAction.redirect();
    }
    
    static filterUserData(data, nonLoginCurrency)  {
      const currency = !data.loginId 
        ? nonLoginCurrency || data.currency
        : data.currency
      
      return {
        'loginId': data.loginId,
        'currency': currency,
        'currentTierId': data.currentTierId,
        'betCredit': CommonUtil.formatBalance(data.betCredit),
        'outstanding': CommonUtil.formatBalance(data.outstanding),
        'message': data.totalMessage,
        'sumAnnouncement': data.sumAnnouncement,
        'sumAnnouncementUnread': data.sumAnnouncementUnread,
        'isRefresh': true
      }
    }
}


// WEBPACK FOOTER //
// ./src/app/actions/AccountAction.js